// REACT
import React, {useState} from 'react';
import ReactDOM from 'react-dom/client';
import { Link } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import './App.scss';

////////////////////////////////////////////////////////////////////////////////
// FIREBASE
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { signInWithEmailAndPassword } from "firebase/auth";
import { signOut } from "firebase/auth";

import { getDatabase, ref, push, set, get, query } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDNAXWAQangn2egGmZGg9AaA1911KZ0HVY",
  authDomain: "fratrank-1278b.firebaseapp.com",
  databaseURL: "https://fratrank-1278b-default-rtdb.firebaseio.com",
  projectId: "fratrank-1278b",
  storageBucket: "fratrank-1278b.appspot.com",
  messagingSenderId: "975126492123",
  appId: "1:975126492123:web:f08edd0647bdf9ecc26dfe",
  measurementId: "G-CJP9NWC1QP"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);

// AUTHENTICATION

//createUserWithEmailAndPassword(auth, "edyuspam@gmail.com", "cs35lproject");

// triggered on sign in/out
onAuthStateChanged(auth, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    const uid = user.uid;
    console.log("signed in", uid);
    // ...
  } else {
    // User is signed out
    console.log("signed out");
  }
});

// signOut(auth);

////////////////////////////////////////////////////////////////////////////////

//
// REACT
//

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
